export enum path_file {
    UserPhoto = '/user/photos/',
    CourseFile = '/course/files/',
    EmployeeTraining = '/employee/training/',
    EmployerPhoto = '/employer/photos/',
    EmployerPrincipal = '/employer/principal/',
    EmployerTeacher = '/employer/teacher/',
    EmployerProject = '/employer/project/',
    EmployeeExperience = '/employee/experience/',
    EmployeeCriminalRecord = '/employee/criminal record/',
    EmployeeCertificate = '/certificates/inhabilidades/',
    EmployeeInterviewReport = '/employee/interview/',
    EmployeeInterviewReportMinified = '/employee/interview-minified/',
    EmployeeWwcRecord = '/employee/wwc/',
    EmployeeDisabilityRecord = '/employee/disability record/',
    EmployeeDNIRecord = '/employee/dni/',
    EmployeeVisaRecord = '/employee/visa/',
    EmployeeLanguage = '/employee/language/',
    EmployeeEducation = '/employee/education/',
    EmployeeResume = '/employee/resume/',
    TrainingInstitute = '/traininginstitute/photos/',
    SalarySettlement = '/employee/salaries/',
    SalaryException = '/employee/salaries exception/',
    ComplaintProtocol = '/employer/protocol/',
    ComplaintDocument = '/complaint/document/',
    EmployerRegulationTemp = '/employer/regulation/temp/',
}
